import {APIError} from 'data/errors';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PutHealthRescheduleAppointments,
	PutHealthRescheduleAppointmentsParams,
	PutHealthRescheduleAppointmentsModel,
} from 'domain/usecases';

export class RemotePutHealthRescheduleAppointments implements PutHealthRescheduleAppointments {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PutHealthRescheduleAppointmentsModel>,
	) {}

	async put(
		params: PutHealthRescheduleAppointmentsParams,
	): Promise<PutHealthRescheduleAppointmentsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'put',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
